import { Globe, Clock, Users, CheckCircle2 } from "lucide-react";
import { IMAGES } from "../../data/site";
import { SectionEyebrow } from "../SectionEyebrow";

const QUICK_STATS = [
    { id: "active", icon: <Users size={20} />, n: "30+", label: "Voluntarios activos" },
    { id: "countries", icon: <Globe size={20} />, n: "5+", label: "Países aliados" },
    { id: "hours", icon: <Clock size={20} />, n: "10K+", label: "Horas anuales" },
];

const INTERNATIONAL_PERKS = [
    "Acompañamiento en español o inglés",
    "Inmersión cultural plena en el Tolima",
    "Certificación de horas voluntarias",
];

export const VolunteerHero = () => (
    <section className="topo-bg py-20 lg:py-28" data-testid="volunteer-hero">
        <div className="container-fe grid lg:grid-cols-2 gap-12 items-center">
            <div>
                <SectionEyebrow>Voluntariado</SectionEyebrow>
                <h1 className="mt-5 font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-brand-navy leading-[1.05]">
                    Sé parte de algo que <span className="text-brand-green">deja huella</span>.
                </h1>
                <p className="mt-7 text-lg text-muted-foreground leading-relaxed">
                    En 15 años hemos descubierto que el voluntariado es una experiencia de doble
                    vía: das tiempo y recibes mucho más. Tenemos espacio para ti, vivas en Ibagué
                    o quieras venir desde otro país.
                </p>
                <div className="mt-8 grid grid-cols-3 gap-4">
                    {QUICK_STATS.map((it) => (
                        <div key={it.id} className="card-flat">
                            <div className="text-brand-green">{it.icon}</div>
                            <div className="font-display font-bold text-2xl text-brand-navy mt-2">{it.n}</div>
                            <div className="text-xs text-muted-foreground mt-1">{it.label}</div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl ring-4 ring-white">
                <img src={IMAGES.volunteers_christmas} alt="Equipo voluntario" className="w-full h-full object-cover" />
            </div>
        </div>
    </section>
);

export const InternationalSection = () => (
    <section className="py-20 lg:py-28 bg-brand-navy text-white relative overflow-hidden">
        <div className="absolute inset-0 grain-bg opacity-30 pointer-events-none" />
        <div className="container-fe relative grid lg:grid-cols-2 gap-14 items-center">
            <div className="aspect-video lg:aspect-square rounded-3xl overflow-hidden ring-4 ring-white/10">
                <img src={IMAGES.children_community} alt="Voluntariado internacional" className="w-full h-full object-cover" />
            </div>
            <div>
                <SectionEyebrow className="[&>span:last-child]:text-brand-green">Voluntariado internacional</SectionEyebrow>
                <h2 className="mt-4 font-display font-bold text-3xl lg:text-5xl leading-tight">
                    Una experiencia que cambia tu mirada sobre el mundo.
                </h2>
                <p className="mt-6 text-white/80 leading-relaxed text-lg">
                    Cada año recibimos jóvenes de Alemania, Francia, Brasil, Estados Unidos y otros países
                    que conviven con nuestra comunidad y aportan desde sus talentos. Si eres
                    extranjero, te ayudamos con integración y un programa estructurado.
                </p>
                <ul className="mt-6 space-y-3">
                    {INTERNATIONAL_PERKS.map((t) => (
                        <li key={t} className="flex items-start gap-3 text-white/85">
                            <CheckCircle2 size={18} className="text-brand-green mt-0.5 shrink-0" />
                            <span>{t}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    </section>
);
